import React from "react";
import { ProcedureComponent } from "../../SecondComponents";
import procedure_banner from "../../secondAssets/Images/procedureCrowns-banner.jpg"

const Crowns = (props) => {
    const { selectedLanguage } = props;
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_procedures}-{selectedLanguage?.txt_crowns}</h1>
                    </div>
                </div>
                <div>
                    <ProcedureComponent {...props} procedureDentistry_banner={procedure_banner} name={selectedLanguage?.txt_crowns} />
                </div>
            </div>
        </div>
    )
}

export default Crowns